import { AbstractControl, ValidationErrors } from '@angular/forms';
import { InvoiceableWorkOrderItem } from '../../domains/models/invoiceable-work-order-item';

export const amountAtMostInvoiceableTotal =
  (item?: InvoiceableWorkOrderItem) =>
  (target: AbstractControl): ValidationErrors | null =>
    !target.value ||
    (target.value ?? 0) * (item?.pricePerUnit ?? 0) <= (item?.remaining ?? 0) * (item?.pricePerUnit ?? 0)
      ? null
      : { maxAmount: true };
